import styled from '@emotion/styled';
import { CloseIcon } from 'src/assets/icons/OldCloseIcon';

export const CloseIconWrapper = styled(CloseIcon, { label: 'CloseIconWrapper' })`
    align-self: start;
    cursor: pointer;
    outline: none;
    width: 24px;
    position: absolute;
    right: 10px;
    margin-top: 24px;
`;
